/**
 * Validate the one time verification code step.
 *
 * We do this via an ajax request, so this is an async function which
 * utilizes a callback.
 *
 * @name validateOneTimeVerificationCode
 *
 * @param {Function} callback - A callback function invoked with (err).
 */
const DEFAULT_ERROR = 'The verification code entered is not correct.';

function validateOneTimeVerificationCode(callback) {
	if (!this.validateOtpUrl) {
		console.error('OTP validate URL not configured');
		callback([new Error('Verification is temporarily unavailable.')]);
		return;
	}

	const params = {
		verification_code: this.collect().get('verification_code'),
	};

	// #6332 — logged-in planners post no email; the server derives it.
	if (this.collect().get('otp_use_account_email') !== '1') {
		params.email = this.collect().get('client_email');
	}

	const request = new URLSearchParams(params);

	fetch(this.validateOtpUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: request
	})
	.then(async response => {
		let data = null;
		try {
			data = await response.json();
		} catch (_) {
			console.warn('OTP validate response was not JSON:', response.status, response.statusText);
		}

		if (!response.ok) {
			// Validation error from backend (422)
			const error = new Error(
				data?.error ?? DEFAULT_ERROR
			);
			error.code = response.status;
			throw error;
		}

		return data;
	})
	.then(response => {
		if (response?.status === 'success') {
			callback();
		} else {
			callback([new Error(
				response?.error ?? DEFAULT_ERROR
			)]);
		}
	})
	.catch(error => {
		console.error('Verification code validation error:', error);

		callback([new Error(
			error.message ?? DEFAULT_ERROR
		)]);
	});
}

export {
	validateOneTimeVerificationCode
}
